<template>
    <div class="pane">
        <!-- 标题 详细信息-->
        <div class="title-box">
            <h2 class="title">详细信息</h2>
        </div>

        <!-- 详细信息内容 -->
        <div class="model-box">
            <div class="item-box" v-for="(item,index) in basicList" :key="index">
                <div class="label">{{item.label}}</div>
                <div class="value">{{item.value}}</div>
            </div>
        </div>

        <!-- 分隔线 -->
        <div class="line"></div>

        <!-- 标题 设计信息-->
        <div class="title-box">
            <h2 class="title">设计信息</h2>
        </div>
         <!-- 设计信息内容 -->
        <div class="model-box">
            <div class="item-box all">
                <div class="label">设计分类</div>
                <div class="value">{{dataSource.designTypeName}}</div>
            </div>
            <div class="item-box all">
                <div class="label">需求详述</div>
                <div class="value" v-html="dataSource.requirementDescription"></div>
            </div>
            <div class="item-box all">
                <div class="label">参考风格例图</div>
                <div class="swiper-box" v-if='swiperList && swiperList.length >0'>
                    <el-carousel indicator-position="outside" :autoplay="false" height="350px" >
                        <el-carousel-item v-for="(item,index) of swiperList" :key="index" :title="item.fileName">
                            <div class="img" :style="{'background-image': 'url(' + item.loadFileBinaryUrl + ')'}" v-if='acceptType.indexOf(item.suffixType) !== -1' @click="downloadUrlFun(item.id)" ></div>
                            <!-- <div class="img backgroundImg"  v-else></div> -->
                            <svg-icon icon-class="icon_file_other" style="width:100%;height:100%;cursor:pointer" @click="downloadUrlFun(item.id)"   v-else/>
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div v-else style="color:#333">
                        未上传
                </div>
            </div>
        </div>

        <!-- 分隔线 -->
        <div class="line"></div>

        <!-- 标题 筛选外包商-->
        <div class="title-box">
            <h2 class="title">筛选外包商</h2>
        </div>

         <!-- 筛选外包商内容 -->
        <div class="model-box">
            <div class="value">{{dataSource.outsourcerName}}</div>
        </div>

        <!-- 分隔线 -->
        <div class="line"></div>

        <!-- 标题 上传需求（需改造）-->
        <div class="title-box">
            <h2 class="title">上传需求（需盖章）</h2>
        </div>

        <!-- 上传需求（需改造）内容 -->
        <div class="model-box">
            <div class="value-box">
                <svg-icon :icon-class="requirementFile.suffixType === 'pdf'?'pdf-icon':'jpg-icon'" class="icon" />
                <span class="title" @click="previewFun(requirementFile)" style="cursor:pointer">{{requirementFile.fileName}}</span>
                <span class="size">（{{fileSize}})</span>
                <!-- <a href="javascript:void(0)" @click="downloadUrlFun" class="download">下载</a> -->
                <el-button type="text" style="color:#3a89ff" @click="downloadUrlFun(requirementFile.id)">下载</el-button>
            </div>
        </div>

        <!-- 分隔线 -->
        <div class="line"></div>

        <!-- 标题 存储空间选择-->
        <div class="title-box">
            <h2 class="title">存储空间选择</h2>
            <el-popover popper-class="gray-popper" placement="right-end" width="260" trigger="hover">
                <div class="text">选择存储空间后，乙方上传的最终完稿文件将自动存储至该空间</div>
                <svg-icon class="icon" icon-class="explain" slot="reference" />
            </el-popover>
        </div>
        <!-- 存储空间选择内容 -->
        <div class="model-box">
            <div class="item-box all">
                <div class="label">完稿文件储存空间 </div>
                <div class="value">{{dataSource.storageFolderName}}</div>
            </div>
         </div>

        <template v-if="flowList.length > 0">
            <!-- 分隔线 -->
            <div class="line" ></div>

            <!-- 标题 拒绝理由-->
            <div class="title-box">
                <h2 class="title">拒绝理由</h2>
            </div>

            <!-- 筛选外包商内容 style="flex-flow:column"-->
            <div class="model-box" >
                <div class="value" v-for="(item,index) of flowList" :key="index">{{item.statusStr}}</div>
            </div>
        </template>

         <!-- 图片预览 -->
        <image-viewer v-if="showViewer" :show-viewer="showViewer" :on-close="closeViewer" :url-list="[bugUrl]" :list-data="detailsData" @download="downloadUrlFun(detailsData.id)" ></image-viewer>
         

    </div>
</template>

<script>
import jsonEditorVue from '../../../../../Sample/views/components-demo/json-editor.vue'
import {byteToStr} from '@/utils'
import ImageViewer from '../ImageViewer'
import {fileType} from '@/utils'
export default {
    components:{ImageViewer},
    props:{
        dataSource:{
            type:Object,
            default:()=>{
                return null
            }
        },
        flowList:{
            type:Array,
            default:()=>{
                return []
            }
        },
    },
    data() {
        return {
            //图片所需参数
            detailsData:[],
            bugUrl:'',
            showViewer:false,

            acceptType:'jpg,png,jpeg',
            basicList:[
              {
                label:'需求编号',
                value: this.dataSource.id
              },
              {
                label:'需求部门',
                value: this.dataSource.departmentName
              },
              {
                label: '需求人',
                value: this.dataSource.createUserName
              },
              {
                label: '需求发起日期',
                value: this.dataSource.createTimeStr
              },
              {
                label: '需求标题',
                value: this.dataSource.title
              },
              {
                label: '计划时间点',
                value: this.dataSource.planTimeStartStr + ' 至 ' + this.dataSource.planTimeEndStr
              },
              {
                label: '预算总金额',
                // value: '人民币 20,000元'  
                value: this.dataSource.budgetCurrency +' '+ this.dataSource.budgetAmount +'元'
              },
              {
                label: '预计所需工时',
                // value: '1 工作日'  
                // value: ((new Date(this.dataSource.planTimeEndStr).getTime() - new Date(this.dataSource.planTimeStartStr).getTime()) / (24*60*60*1000) )+' 工作日'  
                value: this.dataSource.workingDays + ' 工作日'

              }
            ],
            requirementFile:JSON.parse(this.dataSource.requirementFileDetail),
            swiperList:JSON.parse(this.dataSource.referenceFileDetail),
            fileSize:byteToStr(JSON.parse(this.dataSource.requirementFileDetail).fileSize)
        }
    },
    methods:{
        isFileType(type){
          return fileType(type);
        },
         // 关闭图片预览
        closeViewer() {
            // console.log('关闭预览===')
            this.showViewer = false
            this.bugUrl = ''
            this.listData = {}
        },
        previewFun(data){
            if(this.isFileType(data.suffixType) === 'picture' && data.loadFileBinaryUrl) { // 图片 显示大图
                this.bugUrl = data.loadFileBinaryUrl
            }else {// 视频、其它
                this.bugUrl = data.thumbnailImageUrl
            }
            this.detailsData = data
            this.showViewer = true;
        },


        downloadUrlFun(id){
             var form = document.createElement('form')
                document.body.appendChild(form)
                form.setAttribute('style','display:none');
                form.setAttribute('method','post');
                form.setAttribute('action',this.$store.getters.downloadUrl);//下载文件的请求路径
                
                // 创建表单里 input 元素
                var tempInput = document.createElement("input");
                tempInput.type = "hidden";
                tempInput.name = 'fileId';
                tempInput.value = id;
                form.appendChild(tempInput);

                var tempInput2 = document.createElement("input");
                tempInput2.type = "hidden";
                tempInput2.name = 'userId';
                tempInput2.value = this.$store.getters.userId;
                form.appendChild(tempInput2);

                form.submit()
                document.body.removeChild(form)
        }
    }

}
</script>

<style lang="scss" scoped>
   
    // 轮播图
    .swiper-box{
        width:80%;
        height: auto;
        overflow: hidden;
        padding-top: 20px;
        .img{
            cursor: pointer;
            width:auto;
            height: 100%;
            // background-image: url('../../assets/banner1.png');
            background-repeat: no-repeat;
            background-size: contain;
            background-position: center center;
        }
    }
    
</style>